import { Injectable } from '@angular/core';
import { ViewSubjects } from '@sharedlib/common/permissions/types/Permissions';
import { HasPermissionGuard } from './has-permission.guard';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard extends HasPermissionGuard {
  constructor() {
    super('read', ViewSubjects.adminView);
  }
}
